import { type ReactNode, useState } from 'react';
import {
    BodyLargeRegular,
    ChevronDownIcon,
    ChevronUpIcon,
    Icon,
    RowListHasHeaderContext,
    XStack,
    YStack,
} from 'smoothie';

interface FormModuleContainerProps {
    title: string;
    children: ReactNode;
    /** Whether the section can collapse on header press. Defaults to true. */
    collapsible?: boolean;
}

export const FormModuleContainer = ({
    title,
    children,
    collapsible = true,
}: FormModuleContainerProps) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const headerInteractive = collapsible;

    return (
        <YStack borderRadius={24} overflow="hidden" backgroundColor="$gray0">
            <XStack
                backgroundColor="$gray200"
                paddingHorizontal={16}
                paddingVertical={16}
                alignItems="center"
                justifyContent="space-between"
                hoverStyle={
                    headerInteractive ? { cursor: 'pointer' } : undefined
                }
                onPress={
                    headerInteractive
                        ? () => {
                              setIsCollapsed(!isCollapsed);
                          }
                        : undefined
                }
            >
                <BodyLargeRegular>{title}</BodyLargeRegular>
                {collapsible && (
                    <Icon
                        color="$black"
                        size={16}
                        icon={isCollapsed ? ChevronDownIcon : ChevronUpIcon}
                    />
                )}
            </XStack>
            {!isCollapsed && (
                <RowListHasHeaderContext.Provider value>
                    <YStack
                        backgroundColor="$gray100"
                        borderBottomLeftRadius={16}
                        borderBottomRightRadius={16}
                        paddingBottom={16}
                        paddingHorizontal={16}
                        overflow="hidden"
                    >
                        {children}
                    </YStack>
                </RowListHasHeaderContext.Provider>
            )}
        </YStack>
    );
};
